import { denormalize } from "normalizr";
import { debtorProfile } from "../../../api/schema";

const getSimilarDebtors = state => {
  try {
    const items = state.debtor.similarDebtors.ids;

    const denormalized = denormalize(
      { items },
      { items: [debtorProfile] },
      state.entities
    );

    return denormalized.items;
  } catch (err) {
    return [];
  }
};

export default getSimilarDebtors;
